import React from "react";
import classNames from "classnames";
type SVGInsightProps = {
	className?: string;
};
const SVGInsight: React.FC<SVGInsightProps> = (props) => (
	<svg
		width="28"
		height="28"
		viewBox="0 0 28 28"
		fill="none"
		className={classNames("fill-current ws-side-item__icon", props.className)}
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M9.617 23.971H4.1101C3.9284 23.975 3.7541 23.9029 3.6257 23.7744 3.4972 23.646 3.4251 23.4717 3.4251 23.29V18.9517C3.4251 18.77 3.4972 18.5958 3.6257 18.4673 3.7541 18.3389 3.9284 18.2667 4.1101 18.2667H9.443V23.961M17.125 23.975V10.275M17.125 23.975H23.29C23.4717 23.975 23.646 23.9029 23.7744 23.7744 23.9029 23.646 23.975 23.4717 23.975 23.29V4.1101C23.975 3.9284 23.9029 3.7541 23.7744 3.6257 23.646 3.4972 23.4717 3.4251 23.29 3.4251H17.81C17.6284 3.4251 17.4541 3.4972 17.3257 3.6257 17.1972 3.7541 17.125 3.9284 17.125 4.1101V10.275M10.262 23.936V10.96C10.275 10.7784 10.3472 10.6041 10.4757 10.4757 10.6041 10.3472 10.7784 10.275 10.96 10.275H16.287V24.01H10.287" />
	</svg>
);
export default SVGInsight;
